export default __webpack_public_path__ + "static/media/photo_5282747746622312905_y.d458b8ea.jpg";